var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('Tabs',{ref:"Tabs",attrs:{"form":_vm.form,"model":_vm.model}}):_c('Wizard',{ref:"Wizard",attrs:{"form":_vm.form,"model":_vm.model},on:{"form-change":_vm.synchronizeCidadaoSearchData,"exit-busca":_vm.loadCidadaoData,"finish":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }